module.exports = __webpack_public_path__ + "img/video.cf045189.png";